import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { DynamicItemBaseComponent } from '@ups/xplat/dynamic-render';
import '../../dynamic-options-web.augment';

//[attr.id]="'radio_choice_' + index.toString()"
@Component({
  selector: 'ups-dynamic-radio',
  styleUrls: ['dynamic-radio.component.scss'],
  template: `
    <div class="dynamic-field-container" [class.selected]="config?.selected">
      <div class="dynamic-field form-input text-align" [formGroup]="group">
        @if (!config?.options?.ignoreLabel) {
          <label class="radio-heading">
            {{ config?.label }}
          </label>
        }
        @if (!options || !options.length) {
          <div>No options specified for the radio group...</div>
        }
        @for (option of options || []; track option; let index = $index) {
          <label>
            <input
              type="radio"
              [attr.name]="config.formControlName"
              [value]="option"
              [formControlName]="config.formControlName"
            />
            {{ option }}
          </label>
        }
        @if (config?.isFormBuilder) {
          <div
            class="form-builder-mask"
            [class.hidden]="config?.options?.hidden"
          ></div>
        }
      </div>
      @if (config?.isFormBuilder) {
        <div class="form-builder-options">
          <i
            class="fas fa-times ml-3 cursor-pointer c-red"
            (click)="delete()"
          ></i>
          <!-- <i class="fas fa-bars ml-3 cursor-grab "></i> -->
        </div>
      }
    </div>
  `,
  // WI 35584: base-class marks cover async writes; ngDoCheck covers in-place config flags.
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class DynamicRadioComponent
  extends DynamicItemBaseComponent
  implements OnInit
{
  public options: string[] = [];

  ngOnInit() {
    super.ngOnInit();
    // this.group.addControl(this.config.id, new FormControl());
    if (this.config && this.config.options) {
      // console.log(this.config);
      const opts = this.config.options['radio'];
      // if (typeof opts === 'string') {
      //   this.options = JSON.parse(opts);
      // } else {
      this.options = opts;
      // }
    }
  }
}
